import { ComboStepConfig } from '../shared/combo-types'

export const SANACION_PROFUNDA_NAME = 'Sanación Profunda'

export const SANACION_PROFUNDA_PREAMBLE = {
    firstStepIntro:
        'Es la primera parte de un camino de sanación profunda (niño interior → romper patrones repetitivos → mensaje de tus guías).',
    finalStepClosing:
        'cerrá el arco del combo mostrando cómo la sanación del niño interior, la liberación de patrones repetitivos y el mensaje de las guías forman un mismo camino de sanación profunda y renovación del alma.',
}

export const SANACION_PROFUNDA_STEPS: ComboStepConfig[] = [
    {
        step: 1,
        type: 'combo-sanacion-interior',
        title: 'Tirada de Sanación del Niño Interior',
        shortTitle: 'Niño Interior',
    },
    {
        step: 2,
        type: 'combo-sanacion-romper',
        title: 'Tirada de Romper Patrones Repetitivos',
        shortTitle: 'Romper Patrones Repetitivos',
    },
    {
        step: 3,
        type: 'combo-sanacion-guias',
        title: 'Tirada de Mensaje de tus Guías',
        shortTitle: 'Mensaje de tus Guías',
    },
]

export const SANACION_PROFUNDA_TOTAL_STEPS = SANACION_PROFUNDA_STEPS.length
